export const MAX_VISIBLE_OFFICES = 10;

